import { Component, OnInit, ViewChild } from '@angular/core';
import { SalesRegion, Territory, TerritoryPostCodeReportData } from "../../common/model/shared.model";
import { CrmDataByZipTerritoryService } from "../crm-data-by-zip-territory/crm-data-by-zip-territory.service";
import { NotificationService } from "../../common/component/notification/notification.service";
import { TerritoryService } from "./territory.service";
import { DatePipe } from '@angular/common';
import { DxDataGridComponent, DxDropDownBoxComponent, DxListComponent } from 'devextreme-angular';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { Utility } from "../../common/service/utility";

@Component({
  selector: 'app-territory-post-code-defs',
  templateUrl: './territory-post-code-defs.component.html',
  styleUrls: ['./territory-post-code-defs.component.scss']
})
export class TerritoryPostCodeDefsComponent implements OnInit {

  salesSubRegions: SalesRegion[] = [];
  territoriesMap = new Map<number, Territory[]>();
  territories: Territory[];
  selectedSalesRegionIds: number[] = [];
  dataSource: any;
  readonly allowedPageSizes = [10, 20, 50, 100, 200];
  disableReportBtn: boolean = true;
  showGrid: boolean = false;
  isLoadPanelVisible: boolean = true;
  currentDate: string;
  territoryValue: number[] = [];
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  @ViewChild('territorylist', { static: false }) territorylist: DxListComponent;
  @ViewChild('territoryDropDown', { static: false }) territoryDropDown: DxDropDownBoxComponent;

  constructor(private crmDataByZipTerritoryService: CrmDataByZipTerritoryService,
    private notificationService: NotificationService,
    private territoryService: TerritoryService,
    private utility: Utility,
    private datepipe: DatePipe) {
    this.currentDate = this.datepipe.transform((new Date), 'MM/dd/yyyy');
  }

  ngOnInit(): void {
    this.getSalesRegions();
  }

  getSalesRegions() {
    this.territoryService.getSalesRegionList().subscribe({
      next: salesRegionData => {
        this.salesSubRegions = salesRegionData;
        this.isLoadPanelVisible = false;
      },
      error: (error: any) => {
        this.notificationService.alert("error", "Error while fetching Sales Region data", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  onChanged_salesRegion(e) {
    this.selectedSalesRegionIds = e.value;
  }

  getTerritoriesBySalesRegion() {
    this.isLoadPanelVisible = true;
    this.territoryService.getTerritoryListBySalesRegionByArray(this.selectedSalesRegionIds).subscribe({
      next: territoryData => {
        this.territories = territoryData;
        this.isLoadPanelVisible = false;
      },
      error: (error: any) => {
        this.isLoadPanelVisible = false;
        this.notificationService.alert("error", "Error while fetching Territories data", error);
      }
    });
  }

  getReports() {
    this.isLoadPanelVisible = true;
    this.territoryService.getTerritoryPostcodeReportData(this.territoryValue).subscribe({
      next: compressedData => {
        var decompressedData = this.utility.decompressData(compressedData);
        var reportData: TerritoryPostCodeReportData[] = JSON.parse(decompressedData);
        this.showGrid = true;
        this.dataSource = reportData;
        this.isLoadPanelVisible = false;
      },
      error: (error: any) => {
        this.isLoadPanelVisible = false;
        this.notificationService.alert("error", "Error while fetching Territories Post Code Location report data. ", error);
      }
    });
  }

  resetFilters() {
    this.dataGrid.instance.clearFilter();
  }

  exportExcel(e) {
    this.isLoadPanelVisible = true;
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');
    exportDataGrid({
      component: this.dataGrid.instance,
      worksheet: worksheet
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'TerritoryPostCodeReport.xlsx');
        });
    }).then(() => {
      this.isLoadPanelVisible = false;
    });

    e.cancel = true;
  }

  onChanged_Territory(e) {
    this.disableReportBtn = false;
    this.updateSelection(this.territorylist && this.territorylist.instance);
  }

  updateSelection(territorylist) {
    if (!territorylist) return;

    if (!this.territoryValue) {
      territorylist.unselectAll();
    }
  }

  onsegmentListSelectionChanged(e) {
    this.territoryValue = this.territorylist.selectedItemKeys;
  }

}
